import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

interface Props {
  items: FAQItem[];
}

export default function FAQ({ items }: Props) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <div className="space-y-3">
      {items.map((item, idx) => (
        <div
          key={idx}
          className="border border-background-200/70 rounded-lg overflow-hidden"
        >
          <button
            onClick={() => toggle(idx)}
            className="w-full flex items-center justify-between px-5 py-4 text-left bg-background-50 hover:bg-background-100 transition-colors cursor-pointer"
          >
            <span className="font-medium text-foreground-950 text-sm pr-4">
              {item.question}
            </span>
            <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === idx ? 'rotate-180' : ''}`}>
              <i className="ri-arrow-down-s-line text-foreground-500"></i>
            </div>
          </button>
          <div
            className={`overflow-hidden transition-all duration-300 ${
              openIndex === idx ? 'max-h-96' : 'max-h-0'
            }`}
          >
            <div className="px-5 pb-4 text-foreground-600 text-sm leading-relaxed">
              {item.answer}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}